import { z } from 'zod';

export enum DataGridViewType {
  dataTable = 'dataTable',
  treeDataGrid = 'treeDataGrid',
}

const colorLevelValidator = z.object({
  value: z.number(),
  color: z.string(),
});

export type ColorLevel = z.infer<typeof colorLevelValidator>;

export const metricColoringValidator = z.object({
  metric: z.string(),
  levels: z.array(colorLevelValidator),
});

export type MetricColoring = z.infer<typeof metricColoringValidator>;

export type Row = Record<string, string | number>;

export type TreeDataGridRow = { path: string[] } & Record<
  string,
  string | number
>;

export interface DataGroup {
  dimension: string;
  value: string;
}
